import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import {
    addAdmin,
    deleteAdmin,
    getAdmin,
    searchAdmin,
    updateAdmin,
} from '../../../redux/actions/Master.action';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { addOtpData, deleteOtpData, getOtpData, updateOtpData } from '../../../redux/actions/Admin.action';

export default function EmergencyCode() {
    const [show, setShow] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [branchId, setBranchId] = useState();

    const toggle = () => {
        setShow(!show);
    };
    const updateToggle = () => {
        setUpdateModal(!updateModal);
    };
    const deleteToggle = () => {
        setDeleteModal(!deleteModal);
    };

    const dispatch = useDispatch();
    const getOtp = useSelector((state) => state.admin);

    const initialValues = {
        otp: ""
    }

    const validationSchema = Yup.object().shape({
        otp: Yup.string().required('Code is required')
    });

    const [formData, setFormData] = useState({
        otp: ""
    });

    const handleAdminDetail = (values, { resetForm }) => {

        dispatch(addOtpData(values)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleUpadteProblam = (values) => {
        const payload = {
            otp: values.otp,
        };
        dispatch(updateOtpData(payload, branchId)).then(() => {
            setUpdateModal(false);
        });
    };

    const handleDeleteProblam = () => {
        dispatch(deleteOtpData(branchId)).then(() => {
            deleteToggle();
        });
    };

    useEffect(() => {
        dispatch(getOtpData())
    }, []);

    return (
        <>
            <div className="mt-[100px] d-flex justify-content-end">
                <div className="d-flex items-center gap-3">
                    <Button
                        onClick={toggle}
                        className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                    >
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Code
                    </Button>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <h3 className='fw-bold'>Emergency Code</h3>
                </div>
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Otp</Th>
                                <Th>User</Th>
                                <Th style={{ minWidth: '200px' }} className="text-end">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {getOtp?.getOtp?.data?.otpData ? (
                                <Tr>
                                    <Td>{getOtp?.getOtp?.data?.otpData?.otp}</Td>
                                    <Td>{getOtp?.getOtp?.data?.otpSetBy}</Td>
                                    <Td>
                                        <div className="d-flex gap-3 justify-end">
                                            <FaEdit
                                                onClick={() => {
                                                    updateToggle();
                                                    setFormData({ otp: getOtp?.getOtp?.data?.otpData?.otp || '' });
                                                    setBranchId(getOtp?.getOtp?.data?.otpData?._id);
                                                }}
                                                className="cursor-pointer border-green-color fs-5 text-success"
                                                title="update"
                                            />
                                            <MdDelete
                                                onClick={() => {
                                                    deleteToggle();
                                                    setBranchId(getOtp?.getOtp?.data?.otpData?._id);
                                                }}
                                                className="cursor-pointer border-green-color fs-5 text-danger"
                                                title="delete"
                                            />
                                        </div>
                                    </Td>
                                </Tr>
                            ) : (
                                <Tr>
                                    <Td colSpan="3" className="text-center">
                                        No data available
                                    </Td>
                                </Tr>
                            )}
                        </Tbody>

                    </Table>
                </TableContainer>
            </div>

            {/* add problem */}

            <Modal show={show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Code</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleAdminDetail}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Code</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="otp"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('otp', e.target.value)}
                                                value={values.otp}
                                                placeholder="Enter Code"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="name"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* update problem */}

            <Modal show={updateModal} onHide={updateToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Code</Modal.Title>
                </Modal.Header>
                <Formik
                    enableReinitialize={true}
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpadteProblam}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Code</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="otp"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('otp', e.target.value)}
                                                value={values.otp}
                                                placeholder="Enter Code"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="name"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete problem */}

            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDeleteProblam}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
